"use client";

import { ReactNode } from "react";
import StarRatings from "react-star-ratings";
import React from "react";
import MediaGallery from "./MediaGallery";
import RatingBox from "@/components/themes/RatingBox";

// Define the Review interface for productreviewList items
interface Review {
  id?: string;
  username: string;
  user_city: string;
  rating: number;
  comment: string;
  created_at?: string;
  media?: string;
}

interface CommentsViewProps {
  productreviewList: Review[];
  assets: string;
  productaveragerating: string;
  productinfo: any;
  setwritereview: (value: boolean) => void;
  onClose: () => void;
  toggleModal: () => void;
}

const handleAddReview = async (data: any) => {
  try {
    const formData = new FormData();
    formData.append('rating', data.rating.toString());
    formData.append('feedback', data.feedback);
    formData.append('timestamp', data.timestamp);
    data.images.forEach((image: any, index: any) => {
      formData.append(`image${index}`, image);
    });
    // formData.append('productId', productinfo.id);

    const response = await fetch('/api/reviews', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Failed to submit review');
    }

    console.log('Review submitted successfully:', await response.json());
  } catch (error) {
    console.error('Error submitting review:', error);
    throw error; // Let RatingBox handle the error display
  }
};

// // MediaGallery component to handle images and videos
// const MediaGallery = ({ prod, mainurl }: { prod: Review; mainurl: string }) => {
//   if (!prod.media) return null;

//   const mediaItems = JSON.parse(prod.media);
//   return (
//     <div className="flex flex-col">
//       {mediaItems.map((media: string, index: number) => (
//         <div
//           key={index}
//           className={`${
//             media.includes(".mp4") ? "w-[250px]" : "w-[150px]"
//           } h-auto max-w-full overflow-hidden m-2 rounded-[4px]`}
//         >
//           {media.includes(".mp4") ? (
//             <video controls className="w-full h-auto rounded-[4px]">
//               <source src={`${mainurl}/${media}`} type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//           ) : (
//             <img
//               src={`${mainurl}/${media}`}
//               alt={prod.comment}
//               className="w-full h-auto rounded-[4px] object-cover"
//             />
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

export function CommentsView({
  productreviewList,
  assets,
  productaveragerating,
  productinfo,
  setwritereview,
  onClose,
  toggleModal,
}: CommentsViewProps) {
  const storeCode = process.env.NEXT_PUBLIC_STORE_CODE
  const mainurl =
    `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${storeCode}`;

  return (
    <div className="">
      <div className="">
        <div className="max-w-5xl mx-auto ">
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-center items-start space-y-4 justify-between p-4 sticky gap-x-4 top-0 z-40 bg-white">

            <div className="flex items-center">
              <button
                onClick={onClose}
                className="text-2xl font-bold text-gray-600 hover:text-black"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-left-icon lucide-chevron-left"><path d="m15 18-6-6 6-6" /></svg>
              </button>
              <p className="text-[#030712] font-inter text-[14px] font-semibold leading-none">
                {productinfo?.name || "Product Reviews"}
              </p>
            </div>


            <div className="flex items-center gap-x-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-thumbs-up"
              >
                <path d="M7 10v12" />
                <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
              </svg>
              <p className="text-[11px]">
                {Math.round(
                  (productreviewList.filter((prod) => prod.rating >= 4).length /
                    productreviewList.length) *
                  100
                ) || 0}% of verified buyers recommend this brand
              </p>
            </div>

          </div>
          <hr className="w-[90%] mx-auto border-[#E4E4E4]" />

          {/* Main Content */}
          <div className="px-[16px] py-[10px]">


            {/* Rating Summary */}
            <div className="flex flex-col sm:flex-row items-center gap-x-[40px] my-[16px] md:space-y-0 space-y-4">
              <div className="w-full sm:w-1/2 flex flex-col justify-center items-center">
                <div className="flex flex-col justify-center items-center space-y-[10px] bg-white shadow-md rounded-[8px] py-[20px] px-[30px]">
                  <h1 className="text-7xl font-bold">
                    {!isNaN(parseFloat(productaveragerating))
                      ? parseFloat(productaveragerating).toFixed(1)
                      : 0}
                  </h1>
                  <p>({productreviewList.length} ratings)</p>
                  <div className="flex gap-1">
                    <StarRatings
                      rating={productaveragerating ? parseFloat(productaveragerating) : 0}
                      starRatedColor="orange"
                      starDimension="16px"
                      starSpacing="2px"
                      numberOfStars={5}
                    />
                  </div>

                  <RatingBox
                    product={{
                      ...productinfo,
                      imageurl: productinfo.images,
                    }}
                    // assets={assets}
                    onSubmitRating={handleAddReview}
                  />

                  {/* <button
                  className="border border-[#d1d1d1] px-4 font-semibold py-2 text-[#207BB4]"
                  onClick={(event) => {
                    event.preventDefault();
                    setwritereview(true);
                    setTimeout(() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }, 0);
                  }}
                >
                  RATE
                </button> */}
                </div>

              </div>

              {/* Rating Bars */}
              <div className="w-full sm:w-1/2 px-[4px]">
                <div className="flex flex-col gap-y-[16px]">
                  {[5, 4, 3, 2, 1].map((rating) => (
                    <div
                      key={rating}
                      className="flex items-center justify-between gap-x-1"
                    >
                      <p className="text-[12px] w-[10px]">{rating}</p>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star-icon lucide-star"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" /></svg>
                      <div className="rang w-full h-2  rounded-full bg-[#d2d2d2]">
                        <div
                          className="h-2 rounded-full bg-primary"
                          style={{
                            width: `${(productreviewList.filter(
                              (prod) =>
                                prod.rating >= rating &&
                                prod.rating < rating + 1
                            ).length /
                              productreviewList.length) *
                              100
                              }%`,
                          }}
                        ></div>
                      </div>
                      <p className="text-[12px]">
                        {
                          productreviewList.filter(
                            (prod) =>
                              prod.rating >= rating && prod.rating < rating + 1
                          ).length
                        }
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Reviews List */}
            {productreviewList.length > 0 && (
              <div className="mt-4 space-y-4">
                {productreviewList.map((prod, index) => (
                  <div
                    key={prod.id || index}
                    className={`py-4 ${index !== productreviewList.length - 1
                      ? "border-b-2 border-[#E4E4E4]"
                      : ""
                      }`}
                  >
                    <div className="flex space-x-4">
                      <div className="rounded-full border-2 border-dash_menu_light !h-fit">
                        <img
                          className="w-[40px] h-[40px] rounded-full object-cover"
                          src='https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/user_img.jpg'
                          alt="User Avatar"
                        />
                      </div>
                      <div className="space-y-2 w-full">
                        <div className="space-x-4 flex items-center">
                          <p className="text-primary_hover text-[14px] font-semibold">
                            {prod.username}
                          </p>
                          <div className="bg-dash_menu_light px-2 py-1 space-x-1 rounded-[4px] flex items-center w-fit">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-map-pin text-primary"
                            >
                              <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                              <circle cx="12" cy="10" r="3" />
                            </svg>
                            <p className="text-primary text-[14px] font-medium">
                              {prod.user_city}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="flex gap-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <svg
                                key={star}
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className={`lucide lucide-star w-5 h-5 ${prod.rating >= star
                                  ? "fill-yellow-400 stroke-yellow-400"
                                  : "fill-none stroke-gray_text"
                                  }`}
                              >
                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                              </svg>
                            ))}
                          </div>
                        </div>
                        <p>Feedback: {prod.comment}</p>
                        <p className="text-xs text-gray_text">
                          {prod.created_at || "Date not available"}
                        </p>
                        <MediaGallery prod={prod} mainurl={mainurl} />

                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}